import type React from 'react';
import { ForceUpdateLazy, TenantBlockLazy } from '../components/';
import { forceVersionUpdateCondition } from './forceVersionUpdateCondition';
import { tenantBlockCondition } from './tenantBlockCondition';

export type Policies = Policy[];

export interface Policy {
    name: string;
    description: string;
    condition: () => boolean;
    component: React.ComponentType<unknown>;
}
export type PolicyName = any;

/**
 * List of policies to be evaluated by the front door.
 * Add policies in the order of priority.
 * IMPORTANT: Ensure that the "component" is lazy loaded.
 */
const FRONT_DOOR_POLICIES: Policies = [
    {
        name: 'TenantBlock',
        description: 'Tenant has blocked access to Outlook Lite',
        condition: tenantBlockCondition,
        component: TenantBlockLazy,
    },
    {
        name: 'ForceAppVersionUpdate',
        description: 'Force app version update',
        condition: forceVersionUpdateCondition,
        component: ForceUpdateLazy,
    },
];

export const getFrontDoorPolicies = () => FRONT_DOOR_POLICIES;
